import { render, staticRenderFns } from "./StartupPlate.vue?vue&type=template&id=391bd737&scoped=true&"
import script from "./StartupPlate.vue?vue&type=script&lang=js&"
export * from "./StartupPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391bd737",
  null
  
)

export default component.exports